// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fK","advertDetailContactGroup__header":"c-n_fL","advertDetailContactGroup__value":"c-n_fM"};